import React from "react";
import "../../Css/Projects/Projects.css";

const ProgrammingMastery = () => {
  return (
    <div className="project">
      <div className="head">Programming Mastery</div>
      <div className="desc">
        Programming Mastery is an educational platform designed to provide a comprehensive learning experience for programming enthusiasts. It covers multiple programming
        languages, focusing on both fundamental and intermediate topics, allowing learners to build a strong foundation and advance their skills. The platform features structured
        lessons, interactive content, and practical examples to guide learners at every step.
      </div>
      <div className="links">
        <a target="_" href="https://programmingmastery.pages.dev/">
          Website
        </a>
        <a target="_" href="https://github.com/AayushMainali-Github/programming-mastery">
          Github
        </a>
      </div>
    </div>
  );
};

export default ProgrammingMastery;
